<template>
    <div class="mt-3 mb-3">
        <b-row>
            <b-col md="6">
                <b-card>
                    <h4 class="strong">Change Password</h4>
                    <hr />
                    <div v-if="submitStatus != ''">
                        <b-alert variant="success" :show="submitStatus == 'OK'">
                            <strong>Success!</strong> Your password has been successfully updated!
                        </b-alert>
                        <b-alert variant="danger" :show="submitStatus != 'OK'">
                            <strong>Error!</strong> {{ submitStatus }}
                        </b-alert>
                    </div>
                    <b-row>
                        <b-col md="6">
                            <b-form-text>Current Password</b-form-text>
                            <b-input type="password" v-model="currentPassword" />
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col md="6">
                            <b-form-text>New Password</b-form-text>
                            <b-input type="password" v-model="newPassword" />
                        </b-col>
                        <b-col md="6">
                            <b-form-text>Repeat New Password</b-form-text>
                            <b-input type="password" v-model="repeatNewPassword" />
                        </b-col>
                        <b-col md="12" class="mt-4" style="text-align: end">
                            <b-btn variant="primary" @click="didTapSubmit" :disabled="isSubmitting">
                                {{ isSubmitting ? "Updating..." : "Change Password" }}
                            </b-btn>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'change-password',
    data() {
        return {
            currentPassword: "",
            newPassword: "",
            repeatNewPassword: "",

            isSubmitting: false,
            submitStatus: ""
        }
    },
    methods: {
        didTapSubmit() {

            let payload = {
                currentPassword: this.currentPassword,
                newPassword: this.newPassword,
                repeatNewPassword: this.repeatNewPassword
            }

            this.isSubmitting = true
            this.$axios.post("/auth/changePassword", payload).then(response => {

                let res = response.data
                this.submitStatus = res.message

                if(res.message == "OK") {
                    this.currentPassword = ""
                    this.newPassword = ""
                    this.repeatNewPassword = ""
                }
            })
            .catch(error => {
                this.submitStatus = error
            })
            .finally(() => {
                this.isSubmitting = false
            })

        }
    }
}
</script>